import { Controller } from "@hotwired/stimulus"

// Rappel baromètre à l'entrée de l'espace élève : affiche la popup (rendue
// côté serveur, textes i18n dans la vue) sauf si l'élève l'a déjà écartée
// dans cette session pour le même ensemble (baromètre, fenêtre) — la clé
// sessionStorage change quand la fenêtre bascule (début → fin), donc le
// rappel revient au bon moment. RGAA : focus trap, Escape, restitution du focus.
export default class extends Controller {
  static targets = ["overlay"]
  static values = { storageKey: String }

  connect() {
    if (this.dismissedInSession()) return

    this.previouslyFocusedElement = document.activeElement
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
    this.overlayTarget.classList.remove("hidden")
    this.focusFirstElement()
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  later() {
    this.dismiss()
  }

  overlayClicked(event) {
    // Seul un clic sur le fond (pas dans la boîte de dialogue) écarte la popup.
    if (event.target === this.overlayTarget) this.dismiss()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.dismiss()
      return
    }
    if (event.key === "Tab") this.trapFocus(event)
  }

  // --- helpers ---

  dismissedInSession() {
    return sessionStorage.getItem(this.storageKeyValue) === "dismissed"
  }

  dismiss() {
    sessionStorage.setItem(this.storageKeyValue, "dismissed")
    this.overlayTarget.classList.add("hidden")
    document.removeEventListener("keydown", this.handleKeydown)
    if (this.previouslyFocusedElement) this.previouslyFocusedElement.focus()
  }

  focusFirstElement() {
    const firstFocusable = this.focusableElements()[0]
    if (firstFocusable) firstFocusable.focus()
  }

  // Boucle le Tab à l'intérieur de la popup tant qu'elle est ouverte.
  trapFocus(event) {
    const focusable = this.focusableElements()
    if (focusable.length === 0) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  focusableElements() {
    return Array.from(this.overlayTarget.querySelectorAll("a[href], button:not([disabled])"))
  }
}
